import { BROWSER } from 'esm-env'
import { writable } from 'svelte/store'
import { goto } from '$app/navigation'

export const contactExpert = writable(false)
export async function toggleContactExpert() {
	if (BROWSER) {
		// Create a new URL using window.location.href
		const url = new URL(window.location.href)
		url.searchParams.delete('openExpertContact')

		goto(url, { replaceState: true })
		contactExpert.update((value) => !value)
	}
}
